module.exports = __webpack_public_path__ + "img/front image1.04bb246d.svg";